var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationMarkerCarSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28,12c0-6.6171875-5.3828125-12-12-12S4,5.3828125,4,12c0,3.8837891,2.9150391,8.6748047,4.1679688,10.5546875 L13.1315918,30H10v2h12v-2h-3.1315918l4.963623-7.4453125C25.0849609,20.6748047,28,15.8837891,28,12z M16.7226562,29.6132812 c-0.3222656,0.484375-1.1230469,0.484375-1.4453125,0l-5.4453125-8.1679688C7.4326172,17.8457031,6,14.3154297,6,12 C6,6.4863281,10.4863281,2,16,2s10,4.4863281,10,10c0,2.3154297-1.4326172,5.8457031-3.8320312,9.4453125L16.7226562,29.6132812z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1914062,7c-0.2783203,0-0.5566406,0.0654297-0.8095703,0.1904297l-8.3144531,4.1582031 C10.4091797,11.6757812,10,12.3369141,10,13.0732422C10,14.1357422,10.8642578,15,11.9267578,15H14v2.0732422 C14,18.1357422,14.8642578,19,15.9267578,19c0.7363281,0,1.3974609-0.4091797,1.7236328-1.0654297l4.1601562-8.3193359 C21.9345703,9.3652344,22,9.0869141,22,8.8085938C22,7.8115234,21.1884766,7,20.1914062,7z M16,16.8515625V14 c0-0.5527344-0.4472656-1-1-1h-2.7626953l7.53125-3.7666016L16,16.8515625z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkerCarSmall);
export default __webpack_public_path__ + "static/media/location-marker-car--small.4c316f6bafd73b1c1da0c5fccbcd0e32.svg";
export { ForwardRef as ReactComponent };